import { COMMON, ifyouApi, kevinAuthAPI, STORY } from 'apis/config';
import { IDropListProps } from 'utils/types/common';
import { IStaticImage } from 'utils/types/storyTypes';

export const backgroundApi = {
  read: (projectId: string) =>
    kevinAuthAPI
      .get(`resource-manager/static/${projectId}/bg`)
      .then((res) => res.data),
  register: (props) =>
    ifyouApi
      .post(`${STORY}/${props.projectId}/bg-insert`, props.formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data),
  zipUpload: (props) =>
    ifyouApi
      .post(`${STORY}/${props.project_id}/bg-zip-upload`, props.formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data),
  update: (props) =>
    ifyouApi
      .post(`${STORY}/${props.projectId}/bg-update`, props.formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data),
  delete: (props) =>
    ifyouApi
      .post(`${STORY}/${props.projectId}/bg-delete`, { bg_id: props.bgId })
      .then((res) => res.data),
  // live background pair list
  fetchBackgroundPair: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'getLivePairList',
        code: 'bg',
        project_id: projectId,
      })
      .then((res) => {
        const newArr: IDropListProps[] = [];
        res?.data?.map((v, i) =>
          newArr.push({
            key: i,
            value: v.live_bg_id,
            text: v.live_bg_name,
          }),
        );
        newArr.push({ key: newArr?.length, value: -1, text: '없음' });
        return newArr;
      }),
  // NEW API
  backgroundList: (projectId): Promise<IStaticImage[]> =>
    kevinAuthAPI
      .get(`/resource-manager/static/${projectId}/bg`)
      .then((res) => (res.data.list ? res.data.list : [])),
  backgroundInsertMulti: (projectId, formData) =>
    kevinAuthAPI
      .post(`/resource-uploader/multi-upload/${projectId}/bg`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data),
  backgroundUpdateImage: (projectId, id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return kevinAuthAPI
      .patch(`/resource-manager/static/${projectId}/bg/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data);
  },
  backgroundUpdateInfo: (projectId, id, data) => {
    return kevinAuthAPI
      .put(`/resource-manager/static/${projectId}/bg/${id}`, data)
      .then((res) => res.data);
  },
  backgroundDelete: (id) => {
    return kevinAuthAPI
      .delete(`/resource-manager/static/${id}`)
      .then((res) => res.data);
  },
};
